import { UserLogsFilterFormValues } from 'pages/AdminManagement/UserLogs/types';

export type UserId = string & { readonly brand: unique symbol };

export type UserSocialNetwork = {
  application: string;
  contact: string;
};

export enum SocialNetwork {
  TELEGRAM = 'TELEGRAM',
  FACEBOOK = 'FACEBOOK',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum UserStatusFilter {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ALL = 'ALL',
}

export enum UserPermission {
  WRITE = 'wim:write',
  READ = 'wim:read',
  DELETE = 'wim:delete',
  ANALYTICS = 'wim:analytics',
  SYSTEM_ADMIN = 'admin:write',
  ADMIN = 'admin:view',
  SYSTEM_USER = 'system:view',
  USER = 'user:view',
}

export interface User {
  uid: UserId;
  email: string;
  createDate: number;
  updateDate: number;
  fullName?: string;
  position?: string;
  department?: string;
  status?: UserStatus;
  permissions?: UserPermission[];
  deviceGroups?: number[];
  phone?: string;
  socialNetworks?: UserSocialNetwork[];
  mfaEnabled?: boolean;
  forcePasswordRefresh?: boolean;
  expirationDate?: string;
  userGroups: string[];
  role: string;
  enabled?: boolean;
}

export interface CreateUser {
  password?: string | null;
  email: string;
  fullName?: string;
  department?: string;
  phone?: string;
  position?: string;
  status?: UserStatus;
  deviceGroups?: number[];
  userGroups?: string[];
  permissions?: UserPermission[];
  socialNetworks?: UserSocialNetwork[];
  mfaEnabled?: boolean;
  forcePasswordRefresh?: boolean;
  expirationDate?: string;
  role?: string;
}

export interface UpdateUser {
  password?: string | null;
  uid: UserId;
  fullName?: string;
  department?: string;
  email?: string;
  phone?: string;
  position?: string;
  status?: UserStatus;
  deviceGroups?: number[];
  userGroups?: string[];
  permissions?: UserPermission[];
  socialNetworks?: UserSocialNetwork[];
  mfaEnabled?: boolean;
  forcePasswordRefresh?: boolean;
  expirationDate?: string;
  role?: string;
}

export interface UserLogActivityQuery extends UserLogsFilterFormValues {
  initiatorUid?: UserId;
  fileName?: string;
}

export type LogDetails = {
  ip: string;
  userAgent: string;
};

export type UserLogActivity = {
  uid: string;
  initiator: string;
  initiatorUid: string | null;
  action: string;
  entity: string;
  entityUid: string;
  details: {
    ip: string | null;
    userAgent: string | null;
    groupId: number | null;
  };
  context: any | null;
  createDate: number;
  updateDate: number;
};

export type UserEditRequest = Exclude<User, 'uid' | 'createDate' | 'updateDate'>;
